import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import Header from '../components/Header';

const C = {
  trasporto: '#EB1C24', alloggio: '#0071BA', attivita: '#FF5B00', servizi: '#009045',
  dark: '#0a1628', darker: '#060e1c', white: '#ffffff',
  text: '#1a1a2e', textLight: '#6b7280', border: '#e5e7eb', light: '#f5f7fa',
};

// ISO numeric code da destinazione
const DEST_TO_ISO = {
  'italia':380,'italy':380,'roma':380,'rome':380,'milano':380,'venezia':380,'firenze':380,'napoli':380,'torino':380,'sicilia':380,'sardegna':380,
  'spagna':724,'spain':724,'madrid':724,'barcellona':724,'barcelona':724,'siviglia':724,'valencia':724,'ibiza':724,'maiorca':724,
  'francia':250,'france':250,'parigi':250,'paris':250,'nizza':250,'nice':250,'lione':250,'marsiglia':250,'bordeaux':250,
  'germania':276,'germany':276,'berlino':276,'berlin':276,'monaco':276,'munich':276,'amburgo':276,'francoforte':276,
  'regno unito':826,'uk':826,'londra':826,'london':826,'edimburgo':826,'manchester':826,'inghilterra':826,'scozia':826,
  'olanda':528,'amsterdam':528,'netherlands':528,'rotterdam':528,'paesi bassi':528,
  'portogallo':620,'portugal':620,'lisbona':620,'lisbon':620,'porto':620,
  'grecia':300,'greece':300,'atene':300,'athens':300,'santorini':300,'mykonos':300,'corfù':300,'rodi':300,'creta':300,
  'austria':40,'vienna':40,'salisburgo':40,'salzburg':40,'innsbruck':40,
  'svizzera':756,'switzerland':756,'zurigo':756,'zurich':756,'ginevra':756,'berna':756,'lugano':756,
  'cechia':203,'czech':203,'praga':203,'prague':203,
  'ungheria':348,'hungary':348,'budapest':348,
  'polonia':616,'poland':616,'varsavia':616,'warsaw':616,'cracovia':616,'krakow':616,
  'croazia':191,'croatia':191,'dubrovnik':191,'spalato':191,'split':191,'zagabria':191,
  'turchia':792,'turkey':792,'istanbul':792,'antalya':792,'cappadocia':792,
  'norvegia':578,'norway':578,'oslo':578,'bergen':578,
  'svezia':752,'sweden':752,'stoccolma':752,'stockholm':752,
  'danimarca':208,'denmark':208,'copenaghen':208,'copenhagen':208,
  'islanda':352,'iceland':352,'reykjavik':352,
  'finlandia':246,'finland':246,'helsinki':246,
  'russia':643,'mosca':643,'moscow':643,'san pietroburgo':643,
  'giappone':392,'japan':392,'tokyo':392,'kyoto':392,'osaka':392,'hiroshima':392,'nara':392,
  'cina':156,'china':156,'pechino':156,'beijing':156,'shanghai':156,
  'hong kong':344,
  'corea del sud':410,'south korea':410,'seoul':410,'busan':410,
  'tailandia':764,'thailand':764,'bangkok':764,'phuket':764,'chiang mai':764,'koh samui':764,
  'vietnam':704,'hanoi':704,'ho chi minh':704,'da nang':704,'hoi an':704,
  'indonesia':360,'bali':360,'jakarta':360,'lombok':360,
  'singapore':702,
  'india':356,'mumbai':356,'delhi':356,'goa':356,'jaipur':356,'agra':356,
  'nepal':524,'kathmandu':524,
  'maldive':462,'maldives':462,
  'sri lanka':144,
  'dubai':784,'abu dhabi':784,'emirati':784,'uae':784,
  'giordania':400,'jordan':400,'petra':400,'amman':400,
  'israele':376,'israel':376,'tel aviv':376,'gerusalemme':376,
  'egitto':818,'egypt':818,'cairo':818,'sharm el sheikh':818,'hurghada':818,
  'marocco':504,'morocco':504,'marrakech':504,'casablanca':504,'fes':504,
  'sud africa':710,'south africa':710,'cape town':710,'johannesburg':710,
  'kenya':404,'nairobi':404,'mombasa':404,
  'tanzania':834,'zanzibar':834,'dar es salaam':834,
  'usa':840,'stati uniti':840,'new york':840,'los angeles':840,'san francisco':840,'chicago':840,'miami':840,'las vegas':840,'orlando':840,'boston':840,'seattle':840,'hawaii':840,
  'canada':124,'toronto':124,'vancouver':124,'montreal':124,
  'messico':484,'mexico':484,'cancun':484,'città del messico':484,
  'cuba':192,'havana':192,"l'avana":192,
  'repubblica dominicana':214,'punta cana':214,
  'colombia':170,'bogota':170,'cartagena':170,'medellin':170,
  'perù':604,'peru':604,'lima':604,'machu picchu':604,'cusco':604,
  'brasile':76,'brazil':76,'rio de janeiro':76,'sao paulo':76,
  'argentina':32,'buenos aires':32,
  'cile':152,'chile':152,'santiago':152,
  'australia':36,'sydney':36,'melbourne':36,'brisbane':36,'perth':36,
  'nuova zelanda':554,'new zealand':554,'auckland':554,'queenstown':554,
};

// Coordinate per marker sulla mappa
const DEST_TO_COORDS = {
  'tokyo':[139.69,35.69],'kyoto':[135.77,35.01],'osaka':[135.50,34.69],'giappone':[138.25,36.20],
  'new york':[-74.00,40.71],'los angeles':[-118.24,34.05],'san francisco':[-122.42,37.77],'chicago':[-87.63,41.88],'miami':[-80.19,25.77],'usa':[-98.58,39.83],'las vegas':[-115.14,36.17],
  'madrid':[-3.70,40.42],'barcellona':[2.17,41.39],'barcelona':[2.17,41.39],
  'parigi':[2.35,48.86],'paris':[2.35,48.86],
  'londra':[-0.13,51.51],'london':[-0.13,51.51],
  'amsterdam':[4.90,52.37],
  'berlino':[13.40,52.52],'berlin':[13.40,52.52],
  'vienna':[16.37,48.21],'zurigo':[8.54,47.38],'ginevra':[6.14,46.20],
  'praga':[14.42,50.09],'budapest':[19.04,47.50],'varsavia':[21.01,52.23],
  'istanbul':[28.98,41.01],'antalya':[30.71,36.90],
  'atene':[23.73,37.98],'santorini':[25.43,36.39],
  'lisbona':[-9.14,38.72],'porto':[-8.61,41.15],
  'oslo':[10.75,59.91],'stoccolma':[18.07,59.33],'copenaghen':[12.57,55.68],'helsinki':[24.94,60.17],'reykjavik':[-21.94,64.13],
  'dubai':[55.27,25.20],'abu dhabi':[54.37,24.47],
  'tel aviv':[34.78,32.08],'cairo':[31.24,30.04],'sharm el sheikh':[34.33,27.91],
  'marrakech':[-7.99,31.63],'casablanca':[-7.59,33.59],
  'nairobi':[36.82,-1.29],'zanzibar':[39.35,-6.17],'cape town':[18.42,-33.93],
  'bangkok':[100.52,13.75],'phuket':[98.39,7.89],'chiang mai':[98.99,18.79],
  'bali':[115.09,-8.34],'jakarta':[106.84,-6.21],
  'singapore':[103.82,1.35],
  'mumbai':[72.88,19.08],'delhi':[77.21,28.63],'goa':[73.83,15.49],
  'pechino':[116.41,39.91],'beijing':[116.41,39.91],'shanghai':[121.47,31.23],
  'seoul':[126.98,37.57],
  'sydney':[151.21,-33.87],'melbourne':[144.96,-37.81],
  'toronto':[-79.38,43.65],'vancouver':[-123.12,49.28],
  'cancun':[-86.85,21.16],'havana':[-82.38,23.13],
  'lima':[-77.04,-12.05],'machu picchu':[-72.54,-13.16],
  'rio de janeiro':[-43.18,-22.91],'sao paulo':[-46.63,-23.55],
  'buenos aires':[-58.37,-34.61],'santiago':[-70.67,-33.45],
  'mosca':[37.62,55.75],'moscow':[37.62,55.75],
  'auckland':[174.76,-36.87],
};

// Km stima A/R da Roma
const DEST_TO_KM = {
  'austria':1800,'vienna':1800,'svizzera':1400,'zurigo':1400,'ginevra':1400,
  'croazia':1400,'slovenia':1200,'monaco':1200,'münchen':1200,
  'spagna':2600,'madrid':2600,'barcellona':2400,'barcelona':2400,'ibiza':2800,'maiorca':2800,
  'francia':2800,'parigi':2800,'paris':2800,'nizza':1800,'nice':1800,
  'germania':3200,'berlino':3200,'berlin':3200,'amburgo':3400,'francoforte':2800,
  'regno unito':3600,'londra':3600,'london':3600,'edimburgo':3800,
  'portogallo':3400,'lisbona':3400,'porto':3400,
  'grecia':2800,'atene':2800,'santorini':2800,'mykonos':2800,'corfù':2400,'creta':2600,'rodi':2600,
  'olanda':3400,'amsterdam':3400,
  'cechia':2400,'praga':2400,'budapest':2400,'ungheria':2400,
  'polonia':3600,'varsavia':3600,'cracovia':3400,
  'norvegia':4000,'oslo':4000,'bergen':4000,
  'svezia':4000,'stoccolma':4000,
  'danimarca':3600,'copenaghen':3600,
  'finlandia':4400,'helsinki':4400,
  'islanda':5600,'reykjavik':5600,
  'turchia':3800,'istanbul':3800,'antalya':3800,'cappadocia':4000,
  'russia':5200,'mosca':5200,'moscow':5200,
  'egitto':5200,'cairo':5200,'sharm el sheikh':5000,'hurghada':5000,
  'marocco':4000,'marrakech':4000,'casablanca':4000,
  'giordania':5600,'petra':5600,'amman':5600,
  'israele':5600,'tel aviv':5600,
  'dubai':9000,'emirati':9000,'abu dhabi':9000,
  'india':12000,'mumbai':12000,'delhi':12000,'goa':10000,
  'maldive':15000,'sri lanka':14000,'nepal':13000,
  'tailandia':17000,'thailand':17000,'bangkok':17000,'phuket':17000,'chiang mai':17000,
  'vietnam':17000,'hanoi':17000,'ho chi minh':17000,'da nang':17000,
  'indonesia':20000,'bali':20000,'jakarta':20000,
  'singapore':20000,
  'giappone':18000,'japan':18000,'tokyo':18000,'kyoto':18000,'osaka':18000,
  'cina':17000,'china':17000,'pechino':17000,'beijing':17000,'shanghai':17000,
  'hong kong':18000,'corea del sud':18000,'seoul':18000,
  'usa':15000,'stati uniti':15000,'new york':13000,'los angeles':20000,'san francisco':20000,'chicago':16000,'miami':16000,'las vegas':20000,
  'canada':14000,'toronto':14000,'vancouver':20000,'montreal':13000,
  'messico':17000,'mexico':17000,'cancun':17000,
  'cuba':17000,'havana':17000,
  'colombia':18000,'cartagena':18000,'bogota':18000,
  'perù':21000,'peru':21000,'lima':21000,'machu picchu':21000,
  'brasile':19000,'brazil':19000,'rio de janeiro':19000,'sao paulo':19000,
  'argentina':22000,'buenos aires':22000,
  'cile':23000,'chile':23000,'santiago':23000,
  'sud africa':18000,'south africa':18000,'cape town':18000,'johannesburg':18000,
  'kenya':12000,'nairobi':12000,'mombasa':12000,
  'tanzania':13000,'zanzibar':13000,
  'australia':34000,'sydney':34000,'melbourne':34000,'brisbane':34000,
  'nuova zelanda':36000,'auckland':36000,
};


function getIso(dest) {
  if (!dest) return null;
  const l = dest.toLowerCase();
  for (const [k, v] of Object.entries(DEST_TO_ISO)) { if (l.includes(k)) return v; }
  return null;
}
function getCoords(dest) {
  if (!dest) return null;
  const l = dest.toLowerCase();
  for (const [k, v] of Object.entries(DEST_TO_COORDS)) { if (l.includes(k)) return v; }
  return null;
}
function getKm(dest) {
  if (!dest) return 0;
  const l = dest.toLowerCase();
  for (const [k, v] of Object.entries(DEST_TO_KM)) { if (l.includes(k)) return v; }
  return 1500;
}

const PERIODI = [
  { id: 'tutto', label: 'Tutto' },
  { id: 'anno', label: 'Quest\'anno' },
  { id: '3anni', label: 'Ultimi 3 anni' },
  { id: '5anni', label: 'Ultimi 5 anni' },
];

function filtraPerPeriodo(esperienze, periodo) {
  if (periodo === 'tutto') return esperienze;
  const ora = new Date();
  const anni = periodo === 'anno' ? 1 : periodo === '3anni' ? 3 : 5;
  const cutoff = new Date(ora.getFullYear() - anni, ora.getMonth(), ora.getDate());
  return esperienze.filter(e => new Date(e.created_at) >= cutoff);
}

// Converte lon/lat in % sulla mappa SVG (proiezione equirettangolare, lat da +85 a -60)
function coordToPercent(lon, lat) {
  const x = (lon + 180) / 360 * 100;
  const y = (85 - lat) / 145 * 100;
  return { x: Math.max(1, Math.min(99, x)), y: Math.max(1, Math.min(99, y)) };
}

function WorldMap({ markers }) {
  const containerRef = useRef(null);
  const svgWrapRef   = useRef(null);
  const mrkWrapRef   = useRef(null);
  const rafRef       = useRef(null);
  const [svgHtml, setSvgHtml]         = useState('');
  const [zoomDisplay, setZoomDisplay] = useState(1);
  const zoomRef  = useRef(1);
  const posRef   = useRef({ x: 0, y: 0 });
  const dragRef  = useRef(null);
  const movedRef = useRef(false);
  const pinchRef = useRef(null);

  // Carica SVG inline: solo così i singoli path sono cliccabili
  useEffect(() => {
    fetch('/images/mappa.svg')
      .then(r => r.text())
      .then(html => setSvgHtml(html))
      .catch(() => {});
  }, []);

  // Applica transform via rAF, senza React re-render nel loop touch/drag
  const applyTransform = useCallback(() => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      const t = `translate(${posRef.current.x}px,${posRef.current.y}px) scale(${zoomRef.current})`;
      if (svgWrapRef.current) svgWrapRef.current.style.transform = t;
      if (mrkWrapRef.current) mrkWrapRef.current.style.transform = t;
    });
  }, []);

  // Limita posizione ai bordi del contenitore
  const clampPos = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;
    const z = zoomRef.current;
    const mx = el.offsetWidth  * (z - 1) / 2;
    const my = el.offsetHeight * (z - 1) / 2;
    posRef.current = {
      x: Math.max(-mx, Math.min(mx, posRef.current.x)),
      y: Math.max(-my, Math.min(my, posRef.current.y)),
    };
  }, []);

  // Click su path SVG → toggle colore blu; hover → opacity (esclusa Russia, bbox > 500)
  useEffect(() => {
    const el = containerRef.current;
    if (!el || !svgHtml) return;
    const isRussia = (path) => { try { return path.getBBox().width > 500; } catch { return false; } };
    const onClick = (e) => {
      if (movedRef.current) return;
      const path = e.target.closest('path');
      if (!path) return;
      const on = path.getAttribute('data-sel') === '1';
      path.setAttribute('data-sel', on ? '0' : '1');
      path.style.fill = on ? '' : C.alloggio;
    };
    const onOver = (e) => {
      const path = e.target.closest('path');
      if (!path || path.getAttribute('data-sel') === '1' || isRussia(path)) return;
      path.style.opacity = '0.75';
    };
    const onOut = (e) => {
      const path = e.target.closest('path');
      if (path && path.getAttribute('data-sel') !== '1') path.style.opacity = '';
    };
    el.addEventListener('click', onClick);
    el.addEventListener('mouseover', onOver);
    el.addEventListener('mouseout', onOut);
    return () => {
      el.removeEventListener('click', onClick);
      el.removeEventListener('mouseover', onOver);
      el.removeEventListener('mouseout', onOut);
    };
  }, [svgHtml]);

  // Scroll rotella → zoom centrato sul cursore
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const onWheel = (e) => {
      e.preventDefault();
      const f = e.deltaY < 0 ? 1.2 : 1 / 1.2;
      const newZ = Math.min(10, Math.max(1, zoomRef.current * f));
      const rect = el.getBoundingClientRect();
      const ox = e.clientX - rect.left - rect.width  / 2;
      const oy = e.clientY - rect.top  - rect.height / 2;
      const scale = newZ / zoomRef.current;
      posRef.current = { x: ox + (posRef.current.x - ox) * scale, y: oy + (posRef.current.y - oy) * scale };
      zoomRef.current = newZ;
      if (newZ === 1) posRef.current = { x: 0, y: 0 };
      clampPos();
      applyTransform();
      setZoomDisplay(newZ);
    };
    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, [applyTransform, clampPos]);

  // Touch: pinch zoom (2 dita) + pan (1 dito)
  useEffect(() => {
    const el = containerRef.current;
    if (!el || !svgHtml) return;
    const dist = (t) => Math.hypot(t[1].clientX - t[0].clientX, t[1].clientY - t[0].clientY);
    const onStart = (e) => {
      if (e.touches.length >= 2) {
        e.preventDefault();
        dragRef.current = null;
        pinchRef.current = { d: dist(e.touches), z: zoomRef.current };
      } else {
        movedRef.current = false;
        pinchRef.current = null;
        dragRef.current = { sx: e.touches[0].clientX - posRef.current.x, sy: e.touches[0].clientY - posRef.current.y };
      }
    };
    const onMove = (e) => {
      e.preventDefault();
      if (e.touches.length === 2 && pinchRef.current) {
        const newDist = dist(e.touches);
        const scale = newDist / pinchRef.current.d;
        const newZ = Math.min(10, Math.max(1, zoomRef.current * scale));
        pinchRef.current = { d: newDist }; // aggiorna per il prossimo frame (incrementale)
        zoomRef.current = newZ;
        if (newZ === 1) posRef.current = { x: 0, y: 0 };
        clampPos();
        applyTransform();
      } else if (e.touches.length === 1 && dragRef.current) {
        movedRef.current = true;
        posRef.current = { x: e.touches[0].clientX - dragRef.current.sx, y: e.touches[0].clientY - dragRef.current.sy };
        clampPos();
        applyTransform();
      }
    };
    const onEnd = () => { dragRef.current = null; pinchRef.current = null; setZoomDisplay(zoomRef.current); };
    el.addEventListener('touchstart', onStart, { passive: false });
    el.addEventListener('touchmove', onMove, { passive: false });
    el.addEventListener('touchend', onEnd);
    return () => {
      el.removeEventListener('touchstart', onStart, { passive: false });
      el.removeEventListener('touchmove', onMove, { passive: false });
      el.removeEventListener('touchend', onEnd);
    };
  }, [svgHtml, applyTransform, clampPos]);

  // Mouse drag
  const onMouseDown = (e) => {
    movedRef.current = false;
    dragRef.current = { sx: e.clientX - posRef.current.x, sy: e.clientY - posRef.current.y };
  };
  const onMouseMove = (e) => {
    if (!dragRef.current) return;
    movedRef.current = true;
    posRef.current = { x: e.clientX - dragRef.current.sx, y: e.clientY - dragRef.current.sy };
    clampPos();
    applyTransform();
  };
  const onMouseUp = () => { dragRef.current = null; };

  // Bottoni zoom
  const doZoom = (f) => {
    zoomRef.current = Math.min(10, Math.max(1, parseFloat((zoomRef.current * f).toFixed(2))));
    if (zoomRef.current === 1) posRef.current = { x: 0, y: 0 };
    clampPos();
    applyTransform();
    setZoomDisplay(zoomRef.current);
  };
  const zoomReset = () => { zoomRef.current = 1; posRef.current = { x: 0, y: 0 }; applyTransform(); setZoomDisplay(1); };

  const btnBase = {
    width: '38px', height: '38px', border: '1px solid #e5e7eb',
    backgroundColor: 'rgba(255,255,255,0.92)', color: '#0a1628', fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backdropFilter: 'blur(6px)', transition: 'opacity 0.15s', cursor: 'pointer',
  };

  return (
    <div ref={containerRef}
      style={{ position: 'relative', backgroundColor: C.light, overflow: 'hidden', lineHeight: 0, userSelect: 'none', touchAction: 'none', cursor: zoomDisplay > 1 ? 'grab' : 'default' }}
      onMouseDown={onMouseDown} onMouseMove={onMouseMove} onMouseUp={onMouseUp} onMouseLeave={onMouseUp}
    >
      {/* Stili hover e cursor per i path SVG */}
      <style>{`#octa-map,#octa-map svg{display:block;width:100%;height:auto;touch-action:none}#octa-map path{cursor:pointer;transition:fill 0.15s,opacity 0.15s}`}</style>

      {/* SVG inline interattivo */}
      <div id="octa-map" ref={svgWrapRef}
        style={{ transformOrigin: '50% 50%', lineHeight: 0 }}
        dangerouslySetInnerHTML={{ __html: svgHtml }}
      />

      {/* Marker destinazioni (stesso transform dell'SVG) */}
      <div ref={mrkWrapRef}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', transformOrigin: '50% 50%', pointerEvents: 'none' }}>
        {markers.map((m, i) => {
          const { x, y } = coordToPercent(m.coords[0], m.coords[1]);
          const dot = Math.max(5, 9 / zoomDisplay);
          return (
            <div key={i} style={{ position: 'absolute', left: `${x}%`, top: `${y}%`, transform: 'translate(-50%,-50%)' }}>
              <div style={{
                width: `${dot}px`, height: `${dot}px`, borderRadius: '50%',
                backgroundColor: C.alloggio, border: `${Math.max(1, 1.5 / zoomDisplay)}px solid #fff`,
                boxShadow: '0 0 6px rgba(0,0,0,0.8)',
              }} />
            </div>
          );
        })}
      </div>

      {/* Controlli zoom */}
      <div style={{ position: 'absolute', bottom: '16px', right: '16px', zIndex: 10, display: 'flex', flexDirection: 'column' }}>
        <button onClick={() => doZoom(1.5)} disabled={zoomDisplay >= 10}
          style={{ ...btnBase, fontSize: '20px', borderRadius: '8px 8px 0 0', opacity: zoomDisplay >= 10 ? 0.35 : 1 }}>+</button>
        <button onClick={zoomReset}
          style={{ ...btnBase, borderTop: 'none', borderBottom: 'none', fontSize: '13px', color: 'rgba(255,255,255,0.55)' }}>⌂</button>
        <button onClick={() => doZoom(1 / 1.5)} disabled={zoomDisplay <= 1}
          style={{ ...btnBase, fontSize: '20px', borderRadius: '0 0 8px 8px', opacity: zoomDisplay <= 1 ? 0.35 : 1 }}>−</button>
      </div>

      {/* Badge percentuale zoom */}
      {zoomDisplay > 1 && (
        <div style={{
          position: 'absolute', bottom: '16px', left: '16px', zIndex: 10,
          backgroundColor: 'rgba(255,255,255,0.9)', color: C.textLight,
          fontSize: '11px', fontWeight: 700, padding: '4px 10px',
          borderRadius: '20px', border: `1px solid ${C.border}`,
          backdropFilter: 'blur(6px)', fontFamily: 'Roboto, sans-serif',
        }}>
          {Math.round(zoomDisplay * 100)}%
        </div>
      )}
    </div>
  );
}

export default function Profilo() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [esperienze, setEsperienze] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('panoramica');
  const [periodo, setPeriodo] = useState('tutto');
  const [cerca, setCerca] = useState('');
  const [editUsername, setEditUsername] = useState(false);
  const [nuovoUsername, setNuovoUsername] = useState('');
  const [savingUsername, setSavingUsername] = useState(false);
  const [usernameError, setUsernameError] = useState('');

  useEffect(() => {
    const init = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { navigate('/login'); return; }
      setUser(session.user);
      const [{ data: prof }, { data: esp }] = await Promise.all([
        supabase.from('profiles').select('*').eq('id', session.user.id).single(),
        supabase.from('esperienze').select('*').eq('user_id', session.user.id).order('created_at', { ascending: false }),
      ]);
      setProfile(prof);
      setNuovoUsername(prof?.username || '');
      setEsperienze(esp || []);
      setLoading(false);
    };
    init();
  }, [navigate]);

  const espFiltrate = useMemo(() => {
    let res = filtraPerPeriodo(esperienze, periodo);
    if (cerca.trim()) res = res.filter(e => e.destinazione?.toLowerCase().includes(cerca.toLowerCase()) || e.titolo?.toLowerCase().includes(cerca.toLowerCase()));
    return res;
  }, [esperienze, periodo, cerca]);

  const visitedIso = useMemo(() => new Set(espFiltrate.map(e => getIso(e.destinazione)).filter(Boolean)), [espFiltrate]);
  const markers = useMemo(() => espFiltrate.map(e => ({ coords: getCoords(e.destinazione), dest: e.destinazione })).filter(m => m.coords), [espFiltrate]);
  const paesiVisitati = visitedIso.size;
  const totaleNotti = espFiltrate.reduce((s, e) => s + (e.durata_notti || 0), 0);
  const kmPercorsi = espFiltrate.reduce((s, e) => s + getKm(e.destinazione), 0);
  const ultimaDest = espFiltrate[0]?.destinazione || '—';

  const salvaUsername = async () => {
    setUsernameError('');
    if (nuovoUsername.trim().length < 3) { setUsernameError('Minimo 3 caratteri.'); return; }
    setSavingUsername(true);
    const { error } = await supabase.from('profiles').update({ username: nuovoUsername.trim() }).eq('id', user.id);
    if (error) setUsernameError('Salvataggio non riuscito.');
    else { setProfile(p => ({ ...p, username: nuovoUsername.trim() })); setEditUsername(false); }
    setSavingUsername(false);
  };

  const toggleVisibilita = async (id, attuale) => {
    await supabase.from('esperienze').update({ is_pubblica: !attuale }).eq('id', id);
    setEsperienze(prev => prev.map(e => e.id === id ? { ...e, is_pubblica: !attuale } : e));
  };

  const eliminaEsperienza = async (id) => {
    if (!window.confirm('Eliminare questa esperienza?')) return;
    await supabase.from('esperienze').delete().eq('id', id);
    setEsperienze(prev => prev.filter(e => e.id !== id));
  };

  const TABS = [
    { id: 'panoramica', label: 'Panoramica' },
    { id: 'viaggi', label: 'I Miei Viaggi' },
    { id: 'impostazioni', label: 'Impostazioni' },
  ];

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: C.white }}>
      <p style={{ color: C.textLight, fontFamily: 'Roboto, sans-serif' }}>Caricamento...</p>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        @font-face{font-family:'Roboto';src:url('/fonts/Roboto-Regular.ttf');font-weight:400}
        @font-face{font-family:'Roboto';src:url('/fonts/Roboto-Bold.ttf');font-weight:700}
        @font-face{font-family:'Roboto';src:url('/fonts/Roboto-Black.ttf');font-weight:900}
        *{box-sizing:border-box;margin:0;padding:0}
        a{text-decoration:none} button{cursor:pointer} button:hover{opacity:0.85}
        input:focus,textarea:focus{outline:none;border-color:${C.alloggio}!important}
        @media(max-width:1024px){
          .octa-header-p{padding:12px 24px!important}
          .octa-tabnav{padding:0 24px!important}
          .octa-statsbar{padding:0 24px!important}
          .octa-main-p{padding:24px 24px!important}
          .octa-footer-p{padding:24px 32px!important}
        }
        @media(max-width:640px){
          .octa-header-p{padding:12px 16px!important}
          .octa-tabnav{padding:0 4px!important}
          .octa-tabnav button,.octa-tabnav a{padding:12px 12px!important;font-size:13px!important}
          .octa-statsbar{padding:0!important}
          .octa-main-p{padding:24px 16px!important}
          .octa-stats4{grid-template-columns:repeat(2,1fr)!important}
          .octa-footer-p{padding:24px 16px!important;flex-direction:column!important;align-items:flex-start!important}
        }
      `}</style>

      <Header light bg={C.white} />

      {/* TAB NAV */}
      <nav className="octa-tabnav" style={{ backgroundColor: C.white, borderBottom: `1px solid ${C.border}`, padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex' }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              padding: '14px 20px', border: 'none', background: 'transparent', fontSize: '14px', fontWeight: tab === t.id ? 700 : 400,
              color: tab === t.id ? C.text : C.textLight,
              borderBottom: tab === t.id ? `2px solid ${C.alloggio}` : '2px solid transparent',
              transition: 'all 0.15s',
            }}>{t.label}</button>
          ))}
          <a href="/bacheca" style={{ padding: '14px 20px', fontSize: '14px', color: C.textLight }}>Vetrina</a>
        </div>
      </nav>

      {/* STATS BAR */}
      <div className="octa-statsbar" style={{ backgroundColor: C.white, borderBottom: `1px solid ${C.border}`, padding: '0 40px' }}>
        <div style={{ display: 'flex', alignItems: 'stretch', gap: '0', overflowX: 'auto' }}>
          {[
            { label: 'Ultima Esperienza', value: ultimaDest, big: false },
            { label: 'Paesi Visitati', value: paesiVisitati, big: true },
            { label: 'Tempo Totale', value: totaleNotti > 0 ? `${totaleNotti} notti` : '—', big: false },
            { label: 'Km Percorsi', value: kmPercorsi > 0 ? kmPercorsi.toLocaleString('it-IT') : '—', big: true },
            { label: 'Esperienze Fatte', value: espFiltrate.length, big: true },
          ].map(({ label, value, big }, i) => (
            <div key={label} style={{ padding: '14px 28px', borderRight: `1px solid ${C.border}`, flexShrink: 0 }}>
              <p style={{ fontSize: '10px', color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '3px' }}>{label}</p>
              <p style={{ fontSize: big ? '22px' : '15px', fontWeight: 900, color: C.text }}>{value}</p>
            </div>
          ))}
          {/* FILTRI */}
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 0' }}>
            <input
              type="text" placeholder="Cerca destinazione..." value={cerca}
              onChange={e => setCerca(e.target.value)}
              style={{ padding: '7px 14px', borderRadius: '4px', border: `1px solid ${C.border}`, backgroundColor: '#fafafa', color: C.text, fontSize: '13px', width: '200px' }}
            />
            <div style={{ display: 'flex', borderRadius: '8px', overflow: 'hidden', border: `1px solid ${C.border}` }}>
              {PERIODI.map(p => (
                <button key={p.id} onClick={() => setPeriodo(p.id)} style={{
                  padding: '7px 14px', border: 'none', fontSize: '12px', fontWeight: 600,
                  backgroundColor: periodo === p.id ? C.alloggio : '#fafafa',
                  color: periodo === p.id ? C.white : C.textLight,
                }}>{p.label}</button>
              ))}
            </div>
            <a href="/crea" style={{ padding: '8px 18px', borderRadius: '8px', backgroundColor: C.attivita, color: C.white, fontSize: '13px', fontWeight: 700 }}>
              + Nuovo viaggio
            </a>
          </div>
        </div>
      </div>

      {/* ── TAB PANORAMICA ── */}
      {tab === 'panoramica' && (
        <div style={{ backgroundColor: C.white, minHeight: 'calc(100vh - 220px)', paddingTop: '24px' }}>
          <WorldMap markers={markers} />
        </div>
      )}

      {/* ── TAB I MIEI VIAGGI ── */}
      {tab === 'viaggi' && (
        <main className="octa-main-p" style={{ padding: '32px 40px', maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 900 }}>
              {espFiltrate.length} {espFiltrate.length === 1 ? 'esperienza' : 'esperienze'}
              {cerca && ` per "${cerca}"`}
            </h2>
            <a href="/crea" style={{ padding: '10px 20px', borderRadius: '8px', backgroundColor: C.alloggio, color: C.white, fontSize: '14px', fontWeight: 700 }}>+ Nuova</a>
          </div>

          {espFiltrate.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '80px 0' }}>
              <p style={{ fontSize: '40px', marginBottom: '16px' }}>✈️</p>
              <p style={{ color: C.textLight, fontSize: '15px', marginBottom: '24px' }}>
                {cerca ? `Nessun risultato per "${cerca}"` : 'Nessuna esperienza in questo periodo'}
              </p>
              {!cerca && <a href="/crea" style={{ padding: '12px 24px', borderRadius: '10px', backgroundColor: C.alloggio, color: C.white, fontSize: '14px', fontWeight: 700 }}>Crea la prima</a>}
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {espFiltrate.map(e => (
                <div key={e.id} style={{ backgroundColor: C.white, borderRadius: '14px', border: `1px solid ${C.border}`, padding: '18px 24px', display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', gap: '5px', flexShrink: 0 }}>
                    {[{k:'trasporto',c:C.trasporto},{k:'alloggio',c:C.alloggio},{k:'attivita',c:C.attivita},{k:'servizi',c:C.servizi}]
                      .map(s => <div key={s.k} style={{ width: '9px', height: '9px', borderRadius: '50%', backgroundColor: e[s.k] ? s.c : C.border }} />)}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ fontWeight: 700, fontSize: '15px', color: C.text }}>{e.destinazione}</p>
                    {e.titolo && <p style={{ fontSize: '13px', color: C.textLight, marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.titolo}</p>}
                  </div>
                  {e.durata_notti && <span style={{ fontSize: '13px', color: C.textLight, flexShrink: 0 }}>🌙 {e.durata_notti}n</span>}
                  {e.prezzo_totale && <span style={{ fontSize: '13px', fontWeight: 700, color: C.servizi, flexShrink: 0 }}>€{Number(e.prezzo_totale).toLocaleString('it-IT')}</span>}
                  <button onClick={() => toggleVisibilita(e.id, e.is_pubblica)} style={{ padding: '5px 12px', borderRadius: '20px', border: 'none', fontSize: '12px', fontWeight: 700, flexShrink: 0, backgroundColor: e.is_pubblica ? '#f0fdf4' : C.light, color: e.is_pubblica ? '#16a34a' : C.textLight }}>
                    {e.is_pubblica ? '● Pubblica' : '○ Privata'}
                  </button>
                  <button onClick={() => eliminaEsperienza(e.id)} style={{ padding: '5px 10px', borderRadius: '6px', border: `1px solid rgba(235,28,36,0.3)`, backgroundColor: 'rgba(235,28,36,0.06)', color: C.trasporto, fontSize: '12px', flexShrink: 0 }}>
                    Elimina
                  </button>
                </div>
              ))}
            </div>
          )}
        </main>
      )}

      {/* ── TAB IMPOSTAZIONI ── */}
      {tab === 'impostazioni' && (
        <main style={{ padding: '40px 20px', maxWidth: '600px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 900 }}>Impostazioni profilo</h2>

          {/* AVATAR + USERNAME */}
          <div style={{ backgroundColor: C.white, borderRadius: '16px', border: `1px solid ${C.border}`, padding: '28px', display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', backgroundColor: C.alloggio, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ fontSize: '22px', fontWeight: 900 }}>{(profile?.username || 'U').slice(0, 2).toUpperCase()}</span>
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: '12px', color: C.textLight, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Username</p>
              {editUsername ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <input type="text" value={nuovoUsername} onChange={e => setNuovoUsername(e.target.value)}
                    style={{ padding: '10px 14px', borderRadius: '4px', border: `1px solid ${C.border}`, backgroundColor: '#fafafa', color: C.text, fontSize: '16px', fontWeight: 700 }}
                    autoFocus />
                  {usernameError && <p style={{ fontSize: '12px', color: '#f87171' }}>{usernameError}</p>}
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button onClick={salvaUsername} disabled={savingUsername} style={{ padding: '8px 18px', borderRadius: '8px', backgroundColor: C.alloggio, color: C.white, border: 'none', fontSize: '13px', fontWeight: 700 }}>
                      {savingUsername ? 'Salvataggio...' : 'Salva'}
                    </button>
                    <button onClick={() => { setEditUsername(false); setNuovoUsername(profile?.username || ''); }} style={{ padding: '8px 18px', borderRadius: '8px', border: `1px solid ${C.border}`, backgroundColor: 'transparent', color: C.textLight, fontSize: '13px' }}>
                      Annulla
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <p style={{ fontSize: '18px', fontWeight: 700 }}>{profile?.username}</p>
                  <button onClick={() => setEditUsername(true)} style={{ padding: '4px 12px', borderRadius: '6px', border: `1px solid ${C.border}`, backgroundColor: 'transparent', color: C.textLight, fontSize: '12px' }}>
                    Modifica
                  </button>
                </div>
              )}
              <p style={{ fontSize: '13px', color: C.textLight, marginTop: '6px' }}>{user?.email}</p>
            </div>
          </div>

          {/* STATS RIEPILOGO */}
          <div style={{ backgroundColor: C.white, borderRadius: '16px', border: `1px solid ${C.border}`, overflow: 'hidden' }}>
            <div className="octa-stats4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)' }}>
              {[
                { label: 'Esperienze', value: esperienze.length, color: C.trasporto },
                { label: 'Pubblicate', value: esperienze.filter(e => e.is_pubblica).length, color: C.alloggio },
                { label: 'Livello', value: profile?.livello || 1, color: C.attivita },
                { label: 'Punteggio', value: profile?.punteggio || 0, color: C.servizi },
              ].map(({ label, value, color }, i) => (
                <div key={label} style={{ padding: '20px', textAlign: 'center', borderRight: i < 3 ? `1px solid ${C.border}` : 'none' }}>
                  <p style={{ fontSize: '24px', fontWeight: 900, color }}>{value}</p>
                  <p style={{ fontSize: '12px', color: C.textLight, marginTop: '4px' }}>{label}</p>
                </div>
              ))}
            </div>
          </div>
        </main>
      )}

      {/* FOOTER */}
      <footer className="octa-footer-p" style={{ padding: '32px 60px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.darker, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {[C.trasporto, C.alloggio, C.attivita, C.servizi].map((col, i) => (
            <span key={i} style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: col, display: 'inline-block' }} />
          ))}
        </div>
      </footer>
    </div>
  );
}
